import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link } from 'react-router-dom';
import PlacesImg from 'assets/places.svg?react';
import { buildLocationState, useCurrentLocation } from 'hooks/useLocationState';
import { useReleaseFlag } from 'hooks/useReleaseFlags';

const useStyles = makeStyles()(() => ({
  imgContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  img: {
    width: '90vmin',
    height: 'auto',
    maxWidth: 345,
  },
}));

export const EmptyPlaces = (): JSX.Element => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const pinImprovements = useReleaseFlag('pin_drop_improvements');

  const locationState = buildLocationState(useCurrentLocation());

  return (
    <Stack spacing={3} sx={{ flex: 1 }}>
      <Stack spacing={2} sx={{ flex: 1 }}>
        <div className={classes.imgContainer}>
          <PlacesImg className={classes.img} />
        </div>

        <Typography variant="h2" align="center">
          {t('places.heading')}
        </Typography>

        <Typography>{t('places.description')}</Typography>
      </Stack>

      <Button
        fullWidth
        size="large"
        to={{
          pathname: pinImprovements ? `/place/create` : `/add_place`,
          state: pinImprovements ? locationState : {},
          hash: pinImprovements ? undefined : 'allow-back',
        }}
        component={Link}
      >
        {t('places.button')}
      </Button>
    </Stack>
  );
};
